<div class="column activity-container">
  @if (classDetail) {
    <div class="row margin-30px">
      @if (classDetail.ImageData) {
        <img width="20%" height="150px"
          [src]="classDetail.ImageData? 'data:image/png;base64,' + classDetail.ImageData : 'data:image/png;base64,' + classDetail.bannerImage" />
      }
      <section class="class-info__detail" [ngClass]="{'w-100 ms-0' : !classDetail.ImageData}">
        <div class="class-info__detail--header">
          <div class="class-info__detail--header-left">
            <h1 class="class-info__detail__name">{{classDetail.LessonName}}</h1>
            <div class="class-info__detail__location">
              <mat-icon class="location_on" aria-hidden="false" aria-label="location">location_on</mat-icon>
              &nbsp;<span>{{classDetail.LocationName}}</span>
            </div>
          </div>
          @if (classDetail.BaseRate) {
            <div class="class-info__detail--header-right">
              <label for="rate" class="class-info__detail__rate-label">{{'Startingfrom' | translate}}</label>
              <div class="class-info__detail__rate-value">{{operatingCurrency}} {{classDetail.BaseRate | currencyDecimalFormatter}}</div>
            </div>
          }
        </div>
        <div class="class-info__detail--content">
          <div class="class-info__detail__item">
            <label for="start-date" class="class-info__detail__item--label">{{'StartDate' | translate}}</label>
            <div class="class-info__detail__item--value">{{classDetail.StartDate | localizeDate:'L'}}</div>
          </div>
          <div class="class-info__detail__item">
            <label for="endDate" class="class-info__detail__item--label">{{'EndDate' | translate}}</label>
            <div class="class-info__detail__item--value">{{classDetail.EndDate | localizeDate:'L'}}</div>
          </div>
          <div class="class-info__detail__item class-info__detail__item_last">
            <label for="instructor" class="class-info__detail__item--label">{{'Instructor' | translate}}</label>
            <div class="class-info__detail__item--value">{{classDetail.Staffs}}</div>
          </div>
        </div>
      </section>
    </div>
  }

  <div class="activity___selector_content">
    <div class="row m-0 activity-selector">
      <div class="reservation-pannel col-lg-5 col-md-5 column">

        <div class="instructor row">
          <div class="dy-date-picker col-lg-5 col-md-5">
            <dynamic-form [config]="reservationConfig" #form="dynamicForm">
            </dynamic-form>
          </div>
          <div class="dy-date-picker col-lg-5 col-md-5">
            <dynamic-form [config]="locationConfig" #form="dynamicForm">
            </dynamic-form>
          </div>
        </div>
        <div class="date-field">
          <div class="txt-bold">
            {{'SelectDates' | translate}}
          </div>
          <div class="row">
            <div class="dy-date-picker col-lg-5 col-md-5">
              <dynamic-form [config]="from_dateConfig" #form="dynamicForm">
              </dynamic-form>
            </div>
            <div class="dy-date-picker col-lg-5 col-md-5">
              <dynamic-form [config]="to_dateConfig" #form="dynamicForm">
              </dynamic-form>
            </div>
          </div>
        </div>
        <div class="cover-size-field">
          <div class="txt-bold">
            {{'SelectCoverSize' | translate}}
          </div>
          <div class="txt-sub-title">
            {{'NoofStudents' | translate}}
          </div>
          <div class="stu-count">
            <div class="count">
              <dynamic-form [config]="customizeSizeConfig" #form="dynamicForm">
              </dynamic-form>
              @if (!validGroupSize) {
                <span class="custom-error">{{'MisMatchGroupSizeWithClass' | translate}}</span>
              }
            </div>
            <!-- <div class="note">
            {{'minimumsize' | translate}} ( <span> {{minSizeAllowed}} </span>)
          </div> -->
        </div>
        @if (bookingTypeConfig && bookingTypeConfig.length) {
          <div class="booking-type">
            <div class="txt-bold">
              {{'SelectBookingTypes' | translate}}
            </div>
            <div class="bookingtypes-list col-lg-5 col-md-5">
              <dynamic-form [config]="bookingTypeConfig" #form="dynamicForm">
              </dynamic-form>
              @if (!validBookingTypes) {
                <span class="custom-error">{{'MisMatchBookingTypeWithBookingSize'
                  |
                translate}}</span>
              }
            </div>
          </div>
        }
        @if (coverTypeConfig && coverTypeConfig.length) {
          <div class="cover-type">
            <div class="txt-bold">
              {{'SelectCoverTypes' | translate}}
            </div>
            <div class="cover-list col-lg-5 col-md-5">
              <dynamic-form [config]="coverTypeConfig" #form="dynamicForm">
              </dynamic-form>
              @if (!validCoverTypes) {
                <span class="custom-error">{{'MisMatchCoverTypeWithBookingSize' |
                translate}}</span>
              }
            </div>
          </div>
        }

      </div>

    </div>
    @if (showSessionorSlots) {
      <div class="slots col-lg-5 col-md-5">
        @if (isSessionClass
          && SessionSlotsAvailableDates && SessionSlotsAvailableDates.length
          && SessionSlotsAvailableDates[selectedIndex].AvailableSessions
          && SessionSlotsAvailableDates[selectedIndex].AvailableSessions.length) {
          <div class="activity-booking__slot-date column">
            <span class="icon icon-Left-Arrow" [class.disabled]="selectedIndex === 0"
            (click)="navClick(-1)"></span>
            {{SessionSlotsAvailableDates[selectedIndex].AvailableDate | localizeDate : 'DD MMMM, ddd'}}
            <span class="icon icon-Right-Arrow"
              [class.disabled]="selectedIndex === (SessionSlotsAvailableDates.length - 1)"
            (click)="navClick(1)"></span>
            <div class="activity-booking__select-slot-label">
              {{'AvailableTime' | translate}}
            </div>
            <ng-container>
              @for (sessionSlot of SessionSlotsAvailableDates; track sessionSlot; let index = $index) {
                <div
                  class="activity-booking__slots-holder" [class.active]="selectedIndex === index">
                  <app-activity-slot-view [SessionSlots]="sessionSlot.AvailableSessions"
                    [isMultiSlotSelection]="isMultiSlotSelection" (slotClick)="slotChangeListners($event)"
                    [MembershipId]="activityService.membershipId"
                    [AllocationTypes]="activityService.AllocationTypes">
                  </app-activity-slot-view>
                </div>
              }
            </ng-container>
          </div>
        }
        @if (isSessionClass
          && SessionSlotsAvailableDates && SessionSlotsAvailableDates.length
          && SessionSlotsAvailableDates[selectedIndex].AvailableSessions
          && SessionSlotsAvailableDates[selectedIndex].AvailableSessions.length) {
          <mat-checkbox
            (change)="applyToOtherDates(selectedIndex, $event)"> {{'Bookforallavailabledates' | translate}} (
            <span class="date-text">{{SessionSlotsAvailableDates[0].AvailableDate | localizeDate: 'DD MMMM'}} -
              {{SessionSlotsAvailableDates[SessionSlotsAvailableDates.length -1].AvailableDate | date:'dd
            MMMM'}}</span> )
          </mat-checkbox>
        }
        @if (!isSessionClass && classLessonList && classLessonList.length) {
          <app-activity-slot-view
            [SessionSlots]="classLessonList" [isMultiSlotSelection]="isMultiSlotSelection"
            (slotClick)="slotChangeListners($event)" [MembershipId]="activityService.membershipId"
            [AllocationTypes]="activityService.AllocationTypes">
          </app-activity-slot-view>
        }
        @if (!isSessionClass && selectedClassSchedule && selectedClassSchedule.length) {
          <div class="selected-class-schedule"
            >
            @for (selectedDay of selectedClassSchedule; track selectedDay; let index = $index) {
              @if (selectedDay) {
                <div class="selected-class-schedule__row">
                  <div class="selected-class-schedule__day">
                    {{dayOfWeek[index]}}
                  </div>
                  <ul class="selected-class-schedule__session-period-list">
                    @for (slot of selectedDay; track slot) {
                      <li class="selected-class-schedule__session-period-item"
                        >
                        <span>{{slot.Start | localizeDate: 'LT'}} - {{slot.End | localizeDate: 'LT'}}</span>
                      </li>
                    }
                  </ul>
                </div>
              }
            }
          </div>
        }
        @if ((isSessionClass
          && (!SessionSlotsAvailableDates || (SessionSlotsAvailableDates && SessionSlotsAvailableDates.length === 0 )
          || !SessionSlotsAvailableDates[selectedIndex].AvailableSessions
          || (SessionSlotsAvailableDates[selectedIndex].AvailableSessions && SessionSlotsAvailableDates[selectedIndex].AvailableSessions.length === 0))) || (!isSessionClass && (!classLessonList || (classLessonList && classLessonList.length === 0)))) {
          <div class="no-slots-message"
            >
            {{'noSlotsAvailable' | translate}}
          </div>
        }
      </div>
    }
  </div>
</div>
<div class="row button-container pre-next">
  <div class="button-group">
    @if (activityService.operation == Operation.create) {
      <div class="d-inline-block button-gap">
        <app-button [buttontype]="previousButton" (valueChange)="gotoPreviousPage($event)"></app-button>
      </div>
    }
    <div class="d-inline-block button-gap">
      <app-button [buttontype]="nextButton" (valueChange)="gotoNextPage($event)"></app-button>
    </div>
  </div>
</div>
</div>